import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle, Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { IconRedpoints } from '../../../icons'
import { urlResolverGetRedPointsRoot } from '../../../url-handling'

import { RedPointsBenefitDialogRow } from './RedPointsBenefitDialogRow'

export const RedPointsBenefitDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const globalConfig = useGlobalConfigContext()

  return (
    <Dialog
      data-qa-id="redpoints-benefit-dialog"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="redpoints.modal.title" />
      </DialogTitle>
      <DialogContent className="flex-col">
        <div className="mb-3 flex flex-row items-center">
          <IconRedpoints className="size-11 text-dark-brand" />
          <h2 className="ml-2 w-fit text-m font-medium">
            <FormattedMessage id="redpoints.modal.description" />
          </h2>
        </div>
        <RedPointsBenefitDialogRow
          text={<FormattedMessage id="redpoints.modal.benefit1" />}
        />
        <RedPointsBenefitDialogRow
          text={<FormattedMessage id="redpoints.modal.benefit2" />}
        />
        <RedPointsBenefitDialogRow
          text={<FormattedMessage id="redpoints.modal.benefit3" />}
        />

        <div className="rounded-lg bg-light-primary-low p-5">
          <p className="mb-3 text-m font-medium">
            <FormattedMessage id="redpoints.modal.collecting.title" />
          </p>
          <p className="mb-3 text-dark-primary-strong">
            <FormattedMessage id="redpoints.modal.collecting.description" />
          </p>
          <div>
            <Link
              className="flex items-center font-medium text-dark-brand"
              href={urlResolverGetRedPointsRoot(globalConfig)}
            >
              <FormattedMessage id="redpoints.modal.link.signUp" />
              <IconArrowRight className="ml-2 size-8" />
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
